<div class="modal-header">
  <h4 class="modal-title" id="modal-title">Historie</h4>
  <button type="button"
          class="btn-close"
          aria-describedby="modal-title"
          (click)="modal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
  <AdminCard [Item]="Items">

    <table class="table table-striped">
      <thead>
        <tr>
          <th scope="col">LEGS</th>
          <th scope="col">PG</th>
          <th scope="col">Gültig Bis</th>
        </tr>
      </thead>
      <tbody>
        @for (item of Items;  track item; let i = $index) {
        <tr>
          <td>
            {{ item.legs }}
          </td>
          <td>
            {{ item.pg }}
          </td>
          <td>
            {{ item.gueltigBis | date: 'dd.MM.yyyy' }}
          </td>
        </tr>
        }
      </tbody>
    </table>
  </AdminCard>
</div>
